import { InjectionToken } from "@angular/core";
import { DigitsInfo } from "./models/digits-info";
import { TCMCurrencyInputConfig } from "./configs/tcm-currency-input.config";
import { TimePickerConfig } from "./configs/time-picker-config";

export interface TCMFormConfig {
  timePicker?: TimePickerConfig;

  wafCurrencyInput?: TCMCurrencyInputConfig;

  currencySign?: string;

  /**
   * @description digitsInfo Decimal representation options, specified by a string
   * in the following format:<br>
   * <code>{minIntegerDigits}.{minFractionDigits}-{maxFractionDigits}</code>.
   *   - `minIntegerDigits`: The minimum number of integer digits before the decimal point.
   * Default is `1`.
   *   - `minFractionDigits`: The minimum number of digits after the decimal point.
   * Default is `0`.
   *   - `maxFractionDigits`: The maximum number of digits after the decimal point.
   * Default is `3`.
   */
  digitInfo?: string;

  digitInfoPercent?: DigitsInfo;

  dateFormat?: string;
  dateTimeFormat?: string;

  /**
   *
   */
  timeFormat?: string;

  phoneMask?: Array<RegExp | string> | ((string) => Array<RegExp | string>);
}

export const TCM_FORM_CONFIG: InjectionToken<TCMFormConfig> =
  new InjectionToken<TCMFormConfig>("TCMFormConfig");
